import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportCorrelateKpiCharts } from '@api/kpi';

import { IExportKpiCorrelateDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_CORRELATE_CHARTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportCorrelateKpiCharts = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportCorrelateCharts } = useMutation<Array<IExportKpiCorrelateDTO>>({
		mutationKey: [EXPORT_CORRELATE_CHARTS],
		mutationFn: (data: Array<IExportKpiCorrelateDTO>) => exportCorrelateKpiCharts(data),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportChartsError,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return { exportCorrelateCharts };
};
